import { I18nService } from "@bitwarden/common/abstractions/i18n.service";
import { PlatformUtilsService } from "@bitwarden/common/abstractions/platformUtils.service";
import { Component, input } from "@angular/core";
import { CouponData } from "../../../models/interfaces/coupons.interface";
import { Clipboard } from "@capacitor/clipboard";
import {
  GLASS_BUTTON_BG,
  GLASS_BUTTON_SHADOW,
} from "@bitwarden/web-vault/app/models/constants/glass-button.constants";

@Component({
  selector: "app-coupon-details-dialog",
  templateUrl: "./coupon-details-dialog.component.html",
})
export class CouponDetailsDialogComponent {
  coupon = input.required<CouponData>();
  closeDialog = input<() => void>();
  isCopied = false;
  protected readonly glassButtonBg = GLASS_BUTTON_BG;
  protected readonly glassButtonShadow = GLASS_BUTTON_SHADOW;

  constructor(
    private i18nService: I18nService,
    private platformUtilsService: PlatformUtilsService,
  ) {}

  displayCopy(): string[] {
    const coupon = this.coupon();
    if (coupon.approvedCopyShort) {
      return coupon.approvedCopyShort;
    } else if (coupon.approvedCopyMedium) {
      return coupon.approvedCopyMedium;
    } else if (coupon.approvedCopyLong) {
      return coupon.approvedCopyLong;
    } else {
      return [""];
    }
  }

  async copyToClipboard(text: string) {
    const copyTextErrorMessage = this.i18nService.t("copyTextError");
    const promoVoucher = this.coupon()?.promoVoucher;
    if (!promoVoucher) {
      return;
    }

    try {
      await Clipboard.write({
        string: promoVoucher,
      });

      this.isCopied = true;

      setTimeout(() => {
        this.isCopied = false;
      }, 2000);
    } catch (err) {
      this.platformUtilsService.showToast(
        "error",
        this.i18nService.t("errorOccurred"),
        copyTextErrorMessage,
      );
    }
  }

  onRedeem(url?: string) {
    // If a specific URL was passed (from the button), use it.
    // Otherwise, fallback to the main coupon URL.
    const targetUrl = url || this.coupon()?.url;

    if (targetUrl) {
      window.open(targetUrl, "_blank");
    }
    this.closeDialog()?.();
  }
}
